<div class="pt-4 flex flex-col gap-4">
  <div class="flex justify-between items-center">
    <h3 class="text-lg font-medium">{{ 'waters.testimonials.heading' | translate }}</h3>
    <button mat-flat-button color="primary" (click)="add()">
      <mat-icon>add</mat-icon>
      {{ 'waters.testimonials.add' | translate }}
    </button>
  </div>

  @if (isLoading()) {
    <div class="flex justify-center py-8">
      <mat-spinner diameter="32" />
    </div>
  } @else if (testimonials().length === 0) {
    <p class="text-sm text-gray-500 py-4">{{ 'waters.testimonials.empty' | translate }}</p>
  } @else {
    <table mat-table [dataSource]="testimonials()" class="w-full">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.testimonials.field.title' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
      </ng-container>

      <ng-container matColumnDef="site">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.testimonials.field.site' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ siteName(row.siteId) }}</td>
      </ng-container>

      <ng-container matColumnDef="score">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.testimonials.field.score' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.score ?? '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.testimonials.field.createdOn' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.createdOn | date: 'dd-MM-yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="editOn">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.testimonials.field.editOn' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.editOn ? (row.editOn | date: 'dd-MM-yyyy') : '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="text-right">
          <button mat-icon-button (click)="edit(row)" [matTooltip]="'waters.testimonials.edit' | translate">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="delete(row)" [matTooltip]="'waters.testimonials.delete' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>
